import { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { formatRP } from "../../Utils/externalFunctions";

const LaporanChart = ({
  anggaranBuk,
  UMKList,
  UMOList,
  transaksiList,
  isAkumulasi,
}) => {
  const [groupBulanList, setGroupBulanList] = useState(getDefaultGroupBulan);

  const [dataRealisasi, setDataRealisasi] = useState(getDefaultData);
  const [dataRealisasiAkumulasi, setDataRealisasiAkumulasi] =
    useState(getDefaultData);
  const [dataSisa, setDataSisa] = useState(getDefaultData);

  useEffect(() => {
    setGroupBulanList(getGroupBulan(UMKList, UMOList, transaksiList));
  }, [UMKList, UMOList, transaksiList]);

  useEffect(() => {
    if (groupBulanList) calcGroupBulan();
  }, [groupBulanList]);

  const getDefaultGroupBulan = () => ({
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
    7: [],
    8: [],
    9: [],
    10: [],
    11: [],
    12: [],
  });

  const getDefaultData = () => [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  const getGroupBulan = (UMKList, UMOList, transaksiList) => {
    let groupBulan = getDefaultGroupBulan();

    UMKList.map((item) => {
      const date = new Date(item.tanggal_mulai);
      const month = date.getMonth() + 1;
      groupBulan[month].push(item);
    });
    UMOList.map((item) => {
      const date = new Date(item.untuk_tanggal);
      const month = date.getMonth() + 1;
      groupBulan[month].push(item);
    });
    transaksiList.map((item) => {
      const date = new Date(item.tanggal_transaksi);
      const month = date.getMonth() + 1;
      groupBulan[month].push(item);
    });

    return groupBulan;
  };

  const calcGroupBulan = () => {
    let totalAnggaran = 0;
    anggaranBuk.map((item) => {
      totalAnggaran += item.total_anggaran;
    });
    let groupDataRealisasi = getDefaultData();
    let groupDataRealisasiAku = getDefaultData();
    let groupDataSisa = getDefaultData();

    for (let i = 1; i <= 12; i++) {
      groupBulanList[i].map((item) => {
        groupDataRealisasi[i - 1] +=
          parseFloat(item.nilai) || parseFloat(item.nilai_transaksi) || 0;
      });
      groupDataSisa[i - 1] = totalAnggaran - groupDataRealisasi[i - 1];
      for (let j = i; j <= 12; j++) {
        groupDataRealisasiAku[j - 1] += groupDataRealisasi[i - 1];
      }
      totalAnggaran -= groupDataRealisasi[i - 1];
    }
    setDataRealisasi(groupDataRealisasi);
    setDataRealisasiAkumulasi(groupDataRealisasiAku);
    setDataSisa(groupDataSisa);
  };

  var options = {
    series: [
      {
        name: "Sisa",
        data: dataSisa,
      },
      {
        name: "Realisasi",
        data: isAkumulasi ? dataRealisasiAkumulasi : dataRealisasi,
      },
    ],
    colors: ["#5fdc73", "#ef6057"],
    chart: {
      type: "bar",
      height: 350,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "55%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
      ],
    },
    yaxis: {
      title: {
        text: "Rp.",
      },
      labels: {
        formatter: function (val) {
          return formatRP(val);
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return "Rp. " + formatRP(val) + " thousands";
        },
      },
    },
  };

  return (
    <div id="chart">
      <Chart
        options={options}
        series={options.series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default LaporanChart;
